exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skus-end-of-list[data-v-b45f64d2] {\n  width: 4px;\n  height: 4px;\n}\n", ""]);

// exports
